import React, { useEffect } from 'react';
import { portfolioData } from './portfolioData';
import './Portfolio.css';
import PortfolioCarousel from './PortfolioCarousel';
import posthog from 'posthog-js';

const Portfolio = () => {

  useEffect(() => {
    const savedScrollY = sessionStorage.getItem("portfolio-page-scroll");
    if (savedScrollY) {
      window.scrollTo(0, Number(savedScrollY));
      sessionStorage.removeItem("portfolio-page-scroll");
    }

    portfolioData.forEach(section => {
      const savedCarouselScroll = sessionStorage.getItem(
        `portfolio-carousel-scroll-${section.category}`
      );
      if (savedCarouselScroll) {
        const carousel = document.querySelector(
          `.portfolioCardsContainer[data-category="${section.category}"]`
        );
        if (carousel) {
          carousel.scrollLeft = Number(savedCarouselScroll);
        }
        sessionStorage.removeItem(`portfolio-carousel-scroll-${section.category}`);
      }
    });
  }, []);

  const showPortfolio = posthog.isFeatureEnabled("portfolio_section");

  if (!showPortfolio) return null;

  return (
    <section className="portfolioSection">
      <div className="portfolioContent">
        <h1>
          See Our Work in Action by<br/>
          <span>Turning Ideas into Reality.</span>
        </h1>
        <p>
          Explore real-world results we've delivered for startups across industries—from idea to launch.
        </p>
      </div>

      {portfolioData.map((section) => (
        <PortfolioCarousel key={section.id} section={section} />
      ))}
    </section>
  );
};

export default Portfolio;
